import { render, staticRenderFns } from "./BulkFileUploadForm.vue?vue&type=template&id=33f88ba0&"
import script from "./BulkFileUploadForm.vue?vue&type=script&lang=ts&"
export * from "./BulkFileUploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./BulkFileUploadForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports